import { useQuery } from "@tanstack/react-query";
import { Auth } from "aws-amplify";
import { AuthContainer } from "../../components/AuthContainer";
import { AuthenticatorView } from "../auth/AuthenticatorView";
import { PublicUrl } from "../../utils/link.util";

/**
 * Redirects unauthenticated users to the self service landing page
 */
export function IndexRedirect() {
  useQuery(["index-page-auth-check"], async () => {
    try {
      // current authenticated user throws if there's no authenticated user,
      // so we can use that to redirect to the self service landing page
      await Auth.currentAuthenticatedUser();
    } catch {
      window.location.replace(PublicUrl.SELF_SERVICE_LANDING);
    }
  });

  // render the sign-in while credentials get checked
  return (
    <AuthContainer hideRightPane>
      <AuthenticatorView initialState="signIn" />
    </AuthContainer>
  );
}
